import {useEffect, useState} from 'react';
import * as React from 'react';
import Button from '@material-ui/core/Button';
import Box from '@material-ui/core/Box';

import {isAndroid, isIOS, isSamsung, isXiaomi} from '~/helpers/navigator';
import {logEvent} from '~/modules/App/store/gaActions';

import ModalShowGuideWithOptions from './Modals/ModalShowGuide/ModalShowGuideWithOptions';
import ModalShowGuide from './Modals/ModalShowGuide/ModalShowGuide';
import ModalBase from './ModalBase';

interface Props {
  isAndroidBrowser?: boolean;
  isDeviceIos?: boolean;
  onButtonClick?: () => void;
  onClose: () => void;
  open: boolean;
  okBtnText?: string;
}

const ModalLocationBase: React.FC<Props> = ({
  children,
  isAndroidBrowser = isAndroid,
  isDeviceIos = isIOS,
  onButtonClick,
  onClose,
  open,
  okBtnText = 'OK',
}) => {
  const [openGuide, setOpenGuide] = useState(false);

  useEffect(() => {
    if (openGuide) {
      logEvent({
        category: 'location-modal',
        action: 'show-guide',
      });
    }
  }, [openGuide]);

  const isSamsungBrowser = isSamsung;
  const isXiaomiBrowser = isXiaomi;

  const isAllowedBrowser = isDeviceIos || isSamsungBrowser || isXiaomiBrowser || isAndroidBrowser;

  return (
    <ModalBase open={open} onClose={onClose} showOkButton={false}>
      {children}
      <Box px={1.25}>
        <Button
          key="modal-show-guide-btn"
          onClick={onButtonClick || onClose}
          className="mb-1"
          fullWidth
        >
          {okBtnText}
        </Button>
        {isAllowedBrowser && (
          <>
            <Button
              key="modal-show-guide-btn"
              variant="text"
              fullWidth
              className="mb-2"
              onClick={() => setOpenGuide(true)}
            >
              Show Guide
            </Button>
            {isDeviceIos ? (
              <ModalShowGuideWithOptions
                key="modal-show-guide-with-options"
                open={openGuide}
                onClose={() => setOpenGuide(false)}
                isDeviceIos={isDeviceIos}
                isSamsungBrowser={isSamsungBrowser}
                isXiaomiBrowser={isXiaomiBrowser}
                isAndroidBrowser={isAndroidBrowser}
                title="Allowing Location on iPhones"
                subtitle="There are 3 different ways on how you can allow Location access on iPhones. If one method doesn’t fix the problem, please try others."
              />
            ) : (
              <ModalShowGuide
                key="modal-show-guide"
                open={openGuide}
                onClose={() => setOpenGuide(false)}
                isDeviceIos={isDeviceIos}
                isSamsungBrowser={isSamsungBrowser}
                isXiaomiBrowser={isXiaomiBrowser}
                isAndroidBrowser={isAndroidBrowser}
              />
            )}
          </>
        )}
      </Box>
    </ModalBase>
  );
};

export default ModalLocationBase;
